import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

interface SectionType {
  id: string;
  version: number;
  displayName: string;
  iconUrl: string | null;
}

export interface Section {
  id: string;
  position: number;
  isVisible: boolean;
  contentTitle?: string | null;
  sectionType: SectionType;
}

export interface PageSeo {
  title?: string;
  description?: string;
  socialTitle?: string;
  socialDescription?: string;
  socialImageUrl?: string;
}

export interface PageDetailsResponse {
  sections: Section[];
  seo: PageSeo;
}

export const pageDetailsQueryKey = (websiteId: string, pageId: string) =>
  ['plus-website-page-details', websiteId, pageId] as const;

async function fetchPageDetails(websiteId: string, pageId: string) {
  const { data } = await axiosPrivate.get<PageDetailsResponse>(
    `/v3/pharmacist/plus-websites/${websiteId}/versions/preview/pages/${pageId}`
  );
  return data;
}

export function useGetPageDetails({ websiteId, pageId }: { websiteId: string; pageId: string }) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: pageDetailsQueryKey(websiteId, pageId),
    queryFn: () => fetchPageDetails(websiteId, pageId),
    meta: { errorMessage: 'Failed to load page details' },
  });

  return {
    sections: data?.sections ?? [],
    seo: data?.seo ?? {},
    isLoading,
    isError,
    error,
  };
}
